import { render, staticRenderFns } from "./odoo-obligor-limit.vue?vue&type=template&id=387cdf2b&scoped=true&"
import script from "./odoo-obligor-limit.vue?vue&type=script&lang=js&"
export * from "./odoo-obligor-limit.vue?vue&type=script&lang=js&"
import style0 from "./odoo-obligor-limit.vue?vue&type=style&index=0&id=387cdf2b&lang=scss&scoped=true&"
import style1 from "./odoo-obligor-limit.vue?vue&type=style&index=1&id=387cdf2b&lang=scss&scoped=true&"
import style2 from "./odoo-obligor-limit.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387cdf2b",
  null
  
)

export default component.exports